import { render } from "./CandidaterDetails.vue?vue&type=template&id=729b07c2&ts=true"
import script from "./CandidaterDetails.vue?vue&type=script&lang=ts"
export * from "./CandidaterDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__